export const FORNECEDOR_SIM = 1;

export const FORNECEDOR_SIM_TOOLTIP =
  'Cadastro exclusivo via Plataforma Logística';

export const FORNECEDOR_SIM_BANNER =
  'Este é um cadastro de fornecedor e não pode ser editado aqui. Por favor, gerencie este registro pela Plataforma Logística.';

export const FORNECEDOR_SIM_SUBMIT_ERROR =
  'Não é permitido cadastrar ou alterar fornecedor neste sistema. Utilize a Plataforma Logística.';

export function getPlataformaLogisticaUrl() {
  return process.env.VUE_APP_PLATAFORMA_LOGISTICA_URL || '';
}
